export const locale = {
  lang: 'en-CA',
  data: {
    NAV: {
      APPLICATIONS: 'Applications',
      DASHBOARD: {
        TITLE: 'Dashboard',
        TITLE1: 'Dashboard 1',
        TITLE2: 'Dashboard 2',
        TITLE3: 'Dashboard 3',
        TITLE4: 'Dashboard 4',
        TITLE_OPERATIONS: 'Operations',
        TITLE_PERFORMANCE: 'Performance',
      },
      OPERATIONS: {
        TITLE: 'Advanced Dashboard',
      },
      DASHBOARD_DETAILED_JUL: {
        TITLE: 'Dashboard',
      },
      PRODUCTS: {
        TITLE: 'Products',
      },
      CLIENTS: {
        TITLE: 'Clients and enterprises',
      },
      VENUES: {
        TITLE: 'Places',
      },
      ROOMS: {
        TITLE: 'Rooms',
      },
      ORDERS: {
        TITLE: 'Orders',
      },
      REPORTS: {
        TITLE: 'Reports',
      },
      SETTINGS: {
        TITLE: 'Settings',
      },
      SUPPORT: {
        TITLE: 'Support',
      },
      UPGRADE: {
        TITLE: 'Upgrade',
      },
      UPGRADE_FEATURES: {
        TITLE: 'Features',
      },
      UPGRADE_SUBMISSIONS: {
        TITLE: 'Web Submissions',
      },
      UPGRADE_AUTOMATIONS: {
        TITLE: 'Automations',
      },
      UPGRADE_INTEGRATIONS: {
        TITLE: 'Integrations',
      },
      UPGRADE_AI: {
        TITLE: 'AI',
      },
      UPGRADE_REQUEST: {
        TITLE: 'Order',
      },
      CONTACT: {
        TITLE: 'Ticket request',
      },
      KB: {
        TITLE: 'Knowledge Base',
      },
      FAQ: {
        TITLE: 'FAQ',
      },
      PROFILE: {
        TITLE: 'Profile',
      },
      ORGANIZATION: {
        TITLE: 'Organization',
      },
      EMPLOYEES: {
        TITLE: 'Employees',
      },
      TODO: {
        TITLE: 'To Do',
      },
      TEST: {
        TITLE: 'Test Page (dev)',
      },
      ROOM_MANAGEMENT: {
        TITLE: 'Room management',
      },

      ADMIN: 'Admin',
      GOD: 'God',
      GOD_LOCAL_STORAGE: {
        TITLE: 'Local storage',
      },
      GOD_REPORTS: {
        TITLE: 'Reports',
      },
      GOD_EMAILS: {
        TITLE: 'Emails',
      },
      GOD_IMPERSONATION: {
        TITLE: 'Impersonation',
      },
      DEV: 'Dev',
      MODULES: 'Modules',
      MODULE_1: {
        TITLE: 'Module 1',
      },
      MODULE_2: {
        TITLE: 'Module 2',
      },
      FUNCTIONS: {
        TITLE: 'Functions',
      },
      MATERIALS: {
        TITLE: 'Equipments',
      },
      MANAGEMENT: {
        TITLE: 'Management',
      },
      HELP_CENTER: {
        TITLE: 'Help Center',
      },
      DOCUMENTATION: {
        TITLE: 'Knowledge base',
      },
      RELEASE_NOTES: {
        TITLE: 'Release notes',
      },
      SHOPS: {
        TITLE: 'Shops',
      },
      SUBMISSIONS: {
        TITLE: 'Web Submissions',
      },
      SENT_EMAILS: {
        TITLE: 'Sent emails',
      },
      CONGRESSES: {
        TITLE: 'Congresses',
      },
      UPSALE: {
        TITLE: 'Upsale',
      },
      PLATFORM: {
        TITLE: 'Platform',
      },
      GTPHOTO_ANDROID: {
        TITLE: 'GT Photo Android',
      },
      GTPHOTO_IOS: {
        TITLE: 'GT Photo iOS',
      },
      RMS_MAGIC_LINK: {
        TITLE: 'Management (RMS)',
      },
      RMS_MAGIC_LINK_LIVRAISON: {
        TITLE: 'Delivery',
      },
      ROADMAP_MAGIC_LINK: {
        TITLE: 'Roadmap',
      },
    },
  },
  // data: {
  //     'NAV': {
  //         'APPLICATIONS': 'Applications',
  //         'DASHBOARD': {
  //             "TITLE": "Dashboard"
  //         },
  //         'PRODUCTS': {
  //             "TITLE": "Products"
  //         },
  //         'CLIENTS': {
  //             "TITLE": "Clients"
  //         },
  //         'VENUES': {
  //             "TITLE": "Venues"
  //         },
  //         'ORDERS': {
  //             "TITLE": "Orders"
  //         },
  //         'REPORTS': {
  //             "TITLE": "Reports"
  //         },
  //         'SUPPORT': {
  //             "TITLE": "Support"
  //         },
  //         'PROFILE': {
  //             "TITLE": "Profile"
  //         },
  //         'ORGANIZATION': {
  //             "TITLE": "Organization"
  //         },
  //         'EMPLOYEES': {
  //             "TITLE": "Employees"
  //         },
  //         'TODO' : {
  //             "TITLE" : "To Do"
  //         },
  //         'TEST': {
  //             'TITLE': "Test Page (dev)"
  //         },
  //
  //         'ADMIN': "Admin",
  //
  //         'GOD': "God",
  //         'GOD_LOCAL_STORAGE': {
  //             'TITLE': "Local storage"
  //         },
  //         'GOD_EMAILS': {
  //             'TITLE': "Emails"
  //         },
  //         'GOD_IMPERSONATION': {
  //             'TITLE': "Impersonation"
  //         },
  //         'DEV': "Dev",
  //         'MODULES': "Modules",
  //         'MODULE_1' : {
  //             'TITLE' : "Module 1",
  //         },
  //         'MODULE_2' : {
  //             'TITLE' : "Module 2",
  //         },
  //     }
  // }
};
